import styled from 'styled-components';
import { CarNumberStyled } from '../CarNumberStyled';
import { rem } from 'polished';

export const CarNumberStyledAP = styled(CarNumberStyled)`
    color: ${({ theme }) => theme.colors.grey17};
    font-size: ${rem('10px')};
`;
